<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2022-12-26 10:38:32
 * @LastEditors: PF
 * @LastEditTime: 2024-01-15 08:44:32
-->
<template>
  <div>
    <el-dialog class="w1200 h830" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">考试成绩录入</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item>
                <el-select v-model="dataGrid.parms.xqid" placeholder="学期" @change='getlist(1)' clearable class="filter-item" filterable>
                  <el-option v-for="(item) in allXq" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.ksjhid" placeholder="考试计划" @change='getlist(2)' clearable class="filter-item" filterable>
                  <el-option v-for="(item) in kaoshirenwu" :key="item.id" :label="item.ksmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.kmid" placeholder="考试科目" @change='getlist(3)' clearable class="filter-item" filterable>
                  <el-option v-for="(item) in kaoshikemu" :key="item.kskmid" :label="item.kskmmc" :value="item.kskmid" :disabled="item.lrcjfs !== lrcjfsData.shouKeJiaoShiLuRu" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.zt" placeholder="状态" clearable @change='bindTable()' class="filter-item" filterable>
                  <!-- 状态：0-未录入，1-已录入，2-已提交，审核中，9-审核通过，10-审核不通过 -->
                  <el-option label="未录入" :value="0" />
                  <el-option label="已录入" :value="1" />
                  <el-option label="已提交" :value="2" />
                  <el-option label="审核通过" :value="9" />
                  <el-option label="审核不通过" :value="10" />
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <div>
                <el-button class="w200" type="primary" @click="addClick"><span class="iconfont icon-chuangjian"></span>录入</el-button>
                <el-button class="w200" type="primary" @click="tijiaoclick()">提交</el-button>
              </div>
              <div class="top_total">已录入{{yilury}}/未录入{{weiluru}}</div>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- <el-table-column type="selection" align="center" width="55" /> -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <el-table-column fixed prop="kh" label="考号" align="center" width="80" sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column fixed prop="xsxm" label="学生姓名" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column fixed prop="xsbjmc" label="班级" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column fixed prop="xsxh" label="学号" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column fixed prop="fs" label="分数成绩" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span :class="scope.row.sfjg==1||scope.row.sfjg==null?'blek':'red'">{{scope.row.fs}}</span>
                  <span v-if="scope.row.ckzt==ckztData.mianKao">(免考)</span>
                  <span v-if="scope.row.ckzt==ckztData.mianXiu">(免修)</span>
                  <span v-if="scope.row.ckzt==ckztData.queKao">(缺考)</span>
                </template>
              </el-table-column>
              <el-table-column fixed prop="djmc" label="等级成绩" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column fixed prop="jd" label="绩点" align="center" show-overflow-tooltip />
              <el-table-column prop="lrrxm" label="录入人" align="center" show-overflow-tooltip />
              <el-table-column prop="lrsj" label="录入时间" align="center" show-overflow-tooltip width="180" />
              <el-table-column prop="zt" label="状态" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-if="scope.row.zt==0">未录入</span>
                  <span v-if="scope.row.zt==1">已录入</span>
                  <span v-if="scope.row.zt==2">已提交</span>
                  <span v-if="scope.row.zt==9">审核通过</span>
                  <span v-if="scope.row.zt==10">审核不通过</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" align="center">
                <template #default="scope">
                  <el-button link type="primary" v-if="scope.row.zt==1||scope.row.zt==10" @click="openEdit=true; row=scope.row">修改</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
    <add v-if="openAdd" v-model:openAdd="openAdd" :row="row" @ReturnData="bindTable" />
    <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import { ElMessageBox } from 'element-plus'
import {
  actionPost,
  loadList,
  homeCloseWindow,
  loadSelect
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])

const addClick = () => {
  row.value = {
    ksjhid: dataGrid.value.parms.ksjhid,
    kmid: dataGrid.value.parms.kmid
  }
  openAdd.value = true
}

const allXq = ref() // 学期
const kaoshirenwu = ref() // 考试任务
const kskmid = ref() // 考试科目id
const kaoshikemu = ref() // 考试科目
const yilury = ref() // 已录入
const weiluru = ref() // 未录入

// 加载 参考状态 下拉框
const ckztData = ref({ list: [] })
loadSelect({
  url: '/api/v2/jiaowu/kaowukaoshijihua/cankaozhuangtai',
  data: ckztData
})
// 审核状态
const shztData = ref({ list: [] })
loadSelect({
  url: '/api/v2/jiaowu/kaowukaoshijihua/shenhezhuangtai',
  data: shztData
})
// 录入成绩方式
const lrcjfsData = ref([])
loadSelect({
  url: '/api/v2/jiaowu/kaowukaoshijihua/luruchengjifangshi',
  data: lrcjfsData
})

// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openList = ref(false)

// 提交
const tijiaoclick = async () => {
  ElMessageBox.confirm('确认要提交吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      const data = {
        menuId: sessionStorage.getItem('menuId'),
        ksjhid: dataGrid.value.parms.ksjhid,
        kmid: dataGrid.value.parms.kmid
      }
      const options = {
        url: '/api/v2/jiaowu/chengjikaoshirenwucankaoxueshengchengji/tijiaoshenpi',
        data: data
      } // [url]接口地址 [data]
      actionPost(options).then((res) => {
        if (res.code === 200) {
          bindTable()
          successPrompt(res.message)
        } else {
          warningPrompt(res.message)
        }
      })
    })
    .catch()
}
// 搜索框
const getlist = (e) => {
  if (e === 1) {
    ksjhid.value = ''
    kskmid.value = ''
    getkaoshirenwu()
    bindTable()
  } else if (e === 2) {
    kskmid.value = ''
    getkaoshikemu()
    bindTable()
  } else if (e === 3) {
    bindTable()
  }
}
// 获取学期数据
const getxqlist = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: allXq,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          dataGrid.value.parms.xqid = element.id
          getkaoshirenwu()
        }
      })
    }
  })
}
// 考试任务
const getkaoshirenwu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihua/list',
    data: kaoshirenwu,
    parms: {
      ksxqid: dataGrid.value.parms.xqid,
      shzt: shztData.value.shenHeTongGuo
    },
    order: 'ksksrq',
    sort: 'asc',
    loadSuccess: function (res) {
      // dataGrid.value.parms.ksjhid = res.data ? res.data[0].id : ''
      // ksjhid.value = res.data ? res.data[0].id : ''
      getkaoshikemu()
    }
  })
}
// 考试科目
const getkaoshikemu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihua/kemu/list',
    data: kaoshikemu,
    parms: { ksjhid: dataGrid.value.parms.ksjhid },
    order: 'kskmmc',
    sort: 'asc',
    loadSuccess: function (res) {
      try {
        res.data.forEach((element) => {
          if (element.lrcjfs === lrcjfsData.value.tongYiLuRu) {
            throw element
          }
        })
      } catch (e) {
        // dataGrid.value.parms.kmid = res.data[0].kskmid
        // kskmid.value = res.data[0].kskmid
      }
      bindTable()
    }
  })
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'kh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/chengjikaoshirenwucankaoxueshengchengji/pagelistnumber',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      dataGrid.value.total = res.data.pagelist.total
      dataGrid.value.data = res.data.pagelist.list || []
      yilury.value = res.data.ylrNumber
      weiluru.value = res.data.wlrNumber
      dataGrid.value.multipleSelection = []
      dataGrid.value.pagination = {
        // 返回分页所需数据
        pageNo: pageNo || 1,
        pageSize: pageSize || 100,
        total: res.data.pagelist.total
      }
    }
  })
}

watch(
  () => props.open,
  () => {
    if (props.open === 'kaoshichengjiluru') {
      openList.value = true
      getxqlist()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
<style lang="less" scoped>
.red {
  color: red;
}

.button-box {
  justify-content: space-between;
}
</style>
